import { render } from "./NewFolder.vue?vue&type=template&id=722d11ab&scoped=true&ts=true"
import script from "./NewFolder.vue?vue&type=script&lang=ts"
export * from "./NewFolder.vue?vue&type=script&lang=ts"

import "./NewFolder.vue?vue&type=style&index=0&id=722d11ab&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722d11ab"]])

export default __exports__